import Service from './Service';
import GeneralUtils from "../utils/GeneralUtils";
import {SERVER_URL} from "../utils/Constants";

export default class LogMailDetailService extends Service {
    constructor() {
        super();
        this.baseURL = 'logMailDetail';
    }

    findByLogMailId(logMailId) {
        return fetch(SERVER_URL + this.baseURL + '/' + logMailId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}